<div *ngIf="isUpdateAvailable" class="auto-reload">
  {{ "new_version_available" | translate }}
</div>
